import styled from 'styled-components';
import { device } from "../../device";

export const ToggleBtn = styled.button`
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 0;
    height: 56px;
    padding: 0;
    position: absolute;
    top: 0;
    right: 0;
    width: 56px;
    transition-duration: 0.075s;
    transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    outline: 0;
    z-index: 10;
    @media ${device.lg} {
        display: none;
    }
`;
export const Hamburger = styled.div`
    transform: ${({ openNav }) => openNav ? 'rotate(45deg)' : 'translate(0,0)'};
    transition-duration: '0.075s';
    transition-delay: ${({ openNav }) => openNav ? '0.12s' : ''};
    transition-timing-function: ${({ openNav }) => openNav ? 'cubic-bezier(0.215, 0.61, 0.355, 1)' : 'cubic-bezier(0.55, 0.055, 0.675, 0.19)'};
    &,
    &:before,
    &:after {
        background-color: var(--brand);
        height: 2px;
        left: 50%;
        margin-left: -8px;
        width: 16px;
        position: absolute;
        .dark & {
            background-color: #fff;
        }
    }
    &:before,
    &:after {
        content: "";
        display: block;
    }
    &:before {
        top: ${({ openNav }) => openNav ? '0' : '-7px'};
        opacity: ${({ openNav }) => openNav ? '0' : '1'};
        transition: ${({ openNav }) => openNav ? 'top 0.075s ease, opacity 0.075s 0.12s ease' : 'top 0.075s 0.12s ease, opacity 0.075s ease'};
    }
    &:after {
        bottom: ${({ openNav }) => openNav ? '0' : '-7px'};
        transform: ${({ openNav }) => openNav ? 'rotate(-90deg)' : ''};
        transition: ${({ openNav }) => openNav ? 'bottom 0.075s ease, transform 0.075s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1)' : 'bottom 0.075s 0.12s ease, transform 0.075s cubic-bezier(0.55, 0.055, 0.675, 0.19)'};
    }
`;